module.exports = __webpack_public_path__ + "static/media/nextgen.58884e89.jpg";